/* BLED ELEVEN — « Bled Size », le calculateur de taille des fiches t-shirt.
   Markup : snippets/bled-size-guide.liquid · styles : assets/bled-size-guide.css
   - Adulte : homme ou femme, hauteur, poids, âge (facultatif), poitrine, ventre. On estime le tour de poitrine à partir
     de la hauteur et du poids (moyennes de mensurations adultes, hommes et femmes séparés), on l'ajuste selon la
     poitrine, le ventre et l'âge, puis on le compare au tour de poitrine conseillé par Gildan pour chaque taille du
     t-shirt Gildan 5000. Au bord d'une taille ou entre deux tailles, on conseille la plus grande. La confiance dit à
     quel point la mesure estimée tombe au milieu de la taille conseillée.
   - « Valider mon choix » sélectionne la taille sur la fiche et garde les réponses sur l'appareil (localStorage
     « bled-size », 13 mois) pour recommander la bonne taille sur les autres fiches.
   - Enfant : taille de l'enfant (ou taille médiane pour son âge). Rien n'est gardé. */
(function () {
  'use strict';
  if (window.__bsgReady) return;
  window.__bsgReady = true;

  var NB = String.fromCharCode(160);
  var EN = String.fromCharCode(8211);
  var DASH = String.fromCharCode(8212);
  var KEY = 'bled-size';
  var KEEP = 396 * 24 * 3600 * 1000;
  var BRAND = 'Bled Size';

  var DATA = {
    adult: {
      lead: 'T-shirt Gildan 5000, coupe regular, 100' + NB + '% coton. Mesures en centimètres.',
      tip: 'Ton tour de poitrine' + NB + ': mesure-le bras le long du corps, à l’endroit le plus fort, puis compare avec la dernière colonne.',
      cols: ['Largeur', 'Longueur', 'Ton tour de poitrine'],
      rows: [
        { k: 's', t: 'S', w: 46, l: 71, c: [86, 91] },
        { k: 'm', t: 'M', w: 51, l: 74, c: [97, 102] },
        { k: 'l', t: 'L', w: 56, l: 76, c: [107, 112] },
        { k: 'xl', t: 'XL', w: 61, l: 79, c: [117, 122] },
        { k: '2xl', t: '2XL', w: 66, l: 81, c: [127, 132] },
        { k: '3xl', t: '3XL', w: 71, l: 84, c: [137, 142] },
        { k: '4xl', t: '4XL', w: 76, l: 86, c: [147, 152] },
        { k: '5xl', t: '5XL', w: 81, l: 89, c: [157, 163] }
      ]
    },
    junior: {
      lead: 'T-shirt enfant Stanley/Stella en coton bio. Mesures en centimètres.',
      tip: 'Taille de l’enfant' + NB + ': sa taille debout, sans chaussures.',
      cols: ['Largeur', 'Longueur', 'Manche', 'Taille de l’enfant'],
      rows: [
        { k: '3-4', t: '3-4 ans', w: 33, l: 41.9, s: 11.4, h: [98, 104] },
        { k: '5-6', t: '5-6 ans', w: 35.1, l: 46, s: 12.5, h: [110, 116] },
        { k: '7-8', t: '7-8 ans', w: 37.1, l: 51.6, s: 14.5, h: [122, 128] },
        { k: '9-11', t: '9-11 ans', w: 40.9, l: 57.4, s: 16.5, h: [134, 146] },
        { k: '12-13', t: '12-13 ans', w: 43.9, l: 62.5, s: 18.5, h: [152, 158] }
      ]
    },
    toddler: {
      lead: 'Mesures en centimètres. Le fournisseur donne les mesures du vêtement jusqu’au 5/6 ans.',
      tip: 'Taille de l’enfant' + NB + ': sa taille debout, sans chaussures.',
      cols: ['Largeur', 'Longueur', 'Manche', 'Taille de l’enfant'],
      rows: [
        { k: '2', t: '2 ans', w: 33, l: 39.4, s: 12, h: [86, 92] },
        { k: '3', t: '3 ans', w: 35.6, l: 42, s: 12.7, h: [92, 98] },
        { k: '4', t: '4 ans', w: 38.1, l: 44.5, s: 13.3, h: [98, 104] },
        { k: '5/6', t: '5/6 ans', w: 40.6, l: 47, s: 14, h: [104, 116] },
        { k: '7/8', t: '7/8 ans', h: [116, 128] },
        { k: '9/10', t: '9/10 ans', h: [128, 140] }
      ]
    }
  };
  // Taille médiane selon l'âge (courbes de croissance OMS, garçons et filles proches).
  var AGES = [[1, 76], [2, 87], [3, 96], [4, 103], [5, 110], [6, 116], [7, 122], [8, 127], [9, 133], [10, 138], [11, 143], [12, 149], [13, 156], [14, 163]];
  var LIMITS = {
    adult: { h: [130, 230], w: [35, 250], a: [12, 99] },
    kid: { h: [75, 175], a: [1, 14] }
  };

  var active = null, lastTrigger = null;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Outils ---------- */
  function norm(v) {
    var s = String(v == null ? '' : v).toLowerCase().split(' ').join('').split(NB).join('');
    if (s.slice(-3) === 'ans') s = s.slice(0, -3);
    return s;
  }
  function fmt(n) { return String(n).split('.').join(','); }
  function num(v) {
    var s = String(v == null ? '' : v).split(',').join('.').split(' ').join('');
    if (s === '') return null;
    var n = parseFloat(s);
    return isFinite(n) ? n : NaN;
  }
  function findRow(rows, key) {
    for (var i = 0; i < rows.length; i++) if (rows[i].k === key) return i;
    return -1;
  }
  function el(tag, cls, text) {
    var e = document.createElement(tag);
    if (cls) e.className = cls;
    if (text != null) e.textContent = text;
    return e;
  }
  function focusEl(e) {
    if (!e) return;
    try { e.focus({ preventScroll: true }); } catch (x) { try { e.focus(); } catch (y) {} }
  }
  function q(root, sel) { return root.querySelector(sel); }
  function qa(root, sel) { return root.querySelectorAll(sel); }
  function clamp(v, a, b) { return Math.max(a, Math.min(b, v)); }

  /* ---------- Taille gardée sur l'appareil ---------- */
  function loadProfile() {
    try {
      var p = JSON.parse(window.localStorage.getItem(KEY) || 'null');
      if (!p || p.v !== 1 || !p.h || !p.w || !p.t || Date.now() - p.t > KEEP) return null;
      return p;
    } catch (e) { return null; }
  }
  function saveProfile(v) {
    try {
      window.localStorage.setItem(KEY, JSON.stringify({ v: 1, t: Date.now(), sex: v.sex, h: v.h, w: v.w, a: v.a || null, chest: v.chest, belly: v.belly }));
      return true;
    } catch (e) { return false; }
  }

  /* ---------- Préparation d'un guide ---------- */
  function setup(root) {
    if (root.__bsg) return root.__bsg;
    var cfg = {};
    try { cfg = JSON.parse(q(root, '[data-sg-config]').textContent); } catch (e) {}
    var kind = DATA[cfg.kind] ? cfg.kind : 'adult';
    var D = DATA[kind];
    var values = Object.prototype.toString.call(cfg.values) === '[object Array]' ? cfg.values : [];
    var offered = [];
    for (var i = 0; i < values.length; i++) {
      var idx = findRow(D.rows, norm(values[i]));
      if (idx > -1 && offered.indexOf(idx) < 0) offered.push(idx);
    }
    if (!offered.length) for (var j = 0; j < D.rows.length; j++) offered.push(j);
    offered.sort(function (a, b) { return a - b; });
    var st = {
      root: root, cfg: cfg, kind: kind, adult: kind === 'adult', D: D, offered: offered,
      flow: kind === 'adult' ? ['info', 'chest', 'belly'] : ['info'],
      screen: null, timers: [], res: null, memo: null,
      v: { sex: null, h: null, w: null, a: null, chest: null, belly: null },
      unitH: 'cm', unitW: 'kg'
    };
    root.__bsg = st;
    buildTable(st);
    return st;
  }

  function label(st, idx) { return st.D.rows[idx].t; }

  function buildTable(st) {
    var D = st.D, t = q(st.root, '[data-sg-table]');
    q(st.root, '[data-sg-lead]').textContent = D.lead;
    q(st.root, '[data-sg-tip]').textContent = D.tip;
    t.textContent = '';
    var thead = el('thead'), tr = el('tr');
    var th0 = el('th', null, 'Taille'); th0.scope = 'col'; tr.appendChild(th0);
    for (var c = 0; c < D.cols.length; c++) { var th = el('th', null, D.cols[c]); th.scope = 'col'; tr.appendChild(th); }
    thead.appendChild(tr);
    t.appendChild(thead);
    var tb = el('tbody');
    for (var i = 0; i < st.offered.length; i++) {
      var r = D.rows[st.offered[i]], row = el('tr');
      row.setAttribute('data-sg-row', r.k);
      var h = el('th', null, r.t); h.scope = 'row'; row.appendChild(h);
      if (st.adult) {
        row.appendChild(el('td', null, fmt(r.w)));
        row.appendChild(el('td', null, fmt(r.l)));
        row.appendChild(el('td', null, r.c[0] + EN + r.c[1]));
      } else {
        row.appendChild(el('td', null, r.w ? fmt(r.w) : DASH));
        row.appendChild(el('td', null, r.l ? fmt(r.l) : DASH));
        row.appendChild(el('td', null, r.s ? fmt(r.s) : DASH));
        row.appendChild(el('td', null, r.h[0] + EN + r.h[1]));
      }
      tb.appendChild(row);
    }
    t.appendChild(tb);
  }

  /* ---------- Calcul ---------- */
  var CHEST = { narrow: -3, normal: 0, broad: 3.5, xbroad: 6.5 };
  var BELLY = { flat: -1.5, normal: 0, round: 2.5, xround: 5 };
  function estimateChest(p) {
    var c = p.sex === 'f' ? 101.3 + 0.637 * p.w - 0.311 * p.h : 107.5 + 0.552 * p.w - 0.278 * p.h;
    c += CHEST[p.chest] || 0;
    c += BELLY[p.belly] || 0;
    if (p.a) c += clamp((p.a - 35) * 0.06, -1.2, 1.8);
    return c;
  }
  function kidHeight(p) {
    if (p.h) return p.h;
    if (!p.a) return null;
    for (var i = 0; i < AGES.length; i++) if (AGES[i][0] === Math.round(p.a)) return AGES[i][1];
    return p.a > 14 ? 163 : 76;
  }
  // Première taille dont la fourchette conseillée contient la mesure, avec 1,5 cm de marge : au bord haut d'une taille
  // ou entre deux fourchettes, on passe à la taille au-dessus (« entre deux tailles, prends la plus grande »).
  function pick(rows, x, key) {
    for (var i = 0; i < rows.length; i++) {
      var lo = rows[i][key][0], hi = rows[i][key][1];
      if (x <= hi - 1.5) {
        if (i > 0 && x < lo) {
          var g = (lo - x) / Math.max(1, lo - rows[i - 1][key][1]);
          return { i: i, between: true, conf: 84 - 10 * clamp(g, 0, 1) };
        }
        if (i === 0 && x < lo) {
          var under = lo - x;
          return { i: 0, loose: under > 4, conf: under > 4 ? 70 : 86 - under * 3 };
        }
        var mid = (lo + hi) / 2, hw = (hi - lo) / 2 + 1.5;
        return { i: i, conf: 96 - 10 * clamp(Math.abs(x - mid) / hw, 0, 1) };
      }
      if (x <= hi) return rows[i + 1] ? { i: i + 1, between: true, conf: 80 } : { i: i, conf: 84 };
    }
    var over = x - rows[rows.length - 1][key][1];
    return { i: rows.length - 1, tight: true, conf: over > 3 ? 66 : 78 };
  }
  function compute(st, p) {
    var rows = st.D.rows, ideal;
    if (st.adult) ideal = pick(rows, estimateChest(p), 'c');
    else ideal = pick(rows, kidHeight(p), 'h');
    var off = st.offered, idx = ideal.i, edge = '';
    if (off.indexOf(idx) < 0) {
      if (idx > off[off.length - 1]) { edge = 'up'; idx = off[off.length - 1]; }
      else if (idx < off[0]) { edge = 'down'; idx = off[0]; }
      else { for (var k = 0; k < off.length; k++) if (off[k] > idx) { idx = off[k]; break; } }
    }
    if (!edge && ideal.loose && idx === off[0]) edge = 'down';
    if (!edge && ideal.tight && idx === off[off.length - 1]) edge = 'up';
    var conf = Math.round(ideal.conf);
    if (edge) conf = Math.min(conf, 70);
    return { ideal: ideal.i, idx: idx, edge: edge, conf: conf };
  }

  /* ---------- Disponibilité ---------- */
  function variants(st) {
    if (st.vars) return st.vars;
    st.vars = [];
    var form = document.getElementById(st.cfg.form);
    var ta = form && form.querySelector('[data-variant-json]');
    try { st.vars = JSON.parse(ta.value || ta.textContent); } catch (e) {}
    return st.vars;
  }
  function available(st, idx) {
    var list = variants(st), key = st.D.rows[idx].k, opt = 'option' + (st.cfg.pos || 1), seen = false;
    for (var i = 0; i < list.length; i++) {
      if (norm(list[i][opt]) !== key) continue;
      seen = true;
      if (list[i].available) return true;
    }
    return !seen;
  }

  /* ---------- Champs ---------- */
  function input(st, key) { return q(st.root, '[data-sg-input="' + key + '"]'); }
  function readFields(st) {
    var v = st.v, L = st.adult ? LIMITS.adult : LIMITS.kid;
    var errs = {};
    if (st.adult && st.unitH === 'ft') {
      var ft = num(input(st, 'hft').value), inch = num(input(st, 'hin').value);
      var tot = ft == null && inch == null ? null : (ft || 0) * 12 + (inch || 0);
      // Même valeur affichée qu'avant le changement d'unité : on garde les centimètres exacts.
      if (tot == null) v.h = null;
      else if (!(v.h > 0 && Math.round(v.h / 2.54) === tot)) v.h = Math.round(tot * 2.54);
      if (inch != null && (inch < 0 || inch > 11)) v.h = NaN;
    } else {
      v.h = num(input(st, 'h').value);
    }
    if (st.adult) {
      var w = num(input(st, 'w').value);
      if (w == null) v.w = null;
      else if (st.unitW !== 'lb') v.w = w;
      else if (!(v.w > 0 && Math.round(v.w * 2.20462) === w)) v.w = Math.round(w / 2.20462 * 10) / 10;
    }
    v.a = num(input(st, 'a').value);
    if (v.h != null && !(v.h >= L.h[0] && v.h <= L.h[1])) errs.h = true;
    if (st.adult && v.w != null && !(v.w >= L.w[0] && v.w <= L.w[1])) errs.w = true;
    if (v.a != null && !(v.a >= L.a[0] && v.a <= L.a[1])) errs.a = true;
    var filled = st.adult ? v.h != null && v.w != null : v.h != null || v.a != null;
    return { errs: errs, ok: filled && !errs.h && !errs.w && !errs.a, filled: filled };
  }
  function errText(st, key) {
    var L = st.adult ? LIMITS.adult : LIMITS.kid;
    if (key === 'h') {
      if (st.adult && st.unitH === 'ft') return 'Indique une taille entre 4' + NB + 'ft' + NB + '3 et 7' + NB + 'ft' + NB + '6.';
      return 'Indique une taille entre ' + L.h[0] + ' et ' + L.h[1] + NB + 'cm.';
    }
    if (key === 'w') return st.unitW === 'lb' ? 'Indique un poids entre 77 et 550' + NB + 'lb.' : 'Indique un poids entre ' + L.w[0] + ' et ' + L.w[1] + NB + 'kg.';
    return 'Indique un âge entre ' + L.a[0] + ' et ' + L.a[1] + ' ans.';
  }
  function showErrors(st, only) {
    var r = readFields(st), keys = ['h', 'w', 'a'], first = null;
    for (var i = 0; i < keys.length; i++) {
      var k = keys[i], box = q(st.root, '[data-sg-err="' + k + '"]');
      if (!box) continue;
      if (only && only !== k) continue;
      var bad = !!r.errs[k];
      box.hidden = !bad;
      box.textContent = bad ? errText(st, k) : '';
      var field = q(st.root, '[data-sg-field="' + k + '"]');
      if (field) field.classList.toggle('is-bad', bad);
      var ins = field ? qa(field, 'input') : [];
      for (var j = 0; j < ins.length; j++) ins[j].setAttribute('aria-invalid', bad ? 'true' : 'false');
      if (bad && !first) first = q(field, 'input:not([hidden])');
    }
    return { r: r, first: first };
  }
  function fillFields(st) {
    var v = st.v;
    if (st.adult) {
      var cmBox = q(st.root, '[data-sg-h-cm]'), ftBox = q(st.root, '[data-sg-h-ft]');
      cmBox.hidden = st.unitH === 'ft';
      ftBox.hidden = st.unitH !== 'ft';
      q(st.root, '[data-sg-unit-txt="h"]').textContent = st.unitH === 'ft' ? 'ft' : 'cm';
      q(st.root, '[data-sg-unit-txt="w"]').textContent = st.unitW;
      if (st.unitH === 'ft') {
        if (v.h > 0) {
          var tot = Math.round(v.h / 2.54), ft = Math.floor(tot / 12);
          input(st, 'hft').value = String(ft);
          input(st, 'hin').value = String(tot - ft * 12);
        } else { input(st, 'hft').value = ''; input(st, 'hin').value = ''; }
      } else {
        input(st, 'h').value = v.h > 0 ? String(Math.round(v.h)) : '';
      }
      input(st, 'w').value = v.w > 0 ? String(st.unitW === 'lb' ? Math.round(v.w * 2.20462) : Math.round(v.w * 10) / 10).split('.').join(',') : '';
    } else {
      input(st, 'h').value = v.h > 0 ? String(Math.round(v.h)) : '';
    }
    input(st, 'a').value = v.a > 0 ? String(Math.round(v.a)) : '';
  }
  function paintOptions(st) {
    var sx = qa(st.root, '[data-sg-sex]');
    for (var k = 0; k < sx.length; k++) sx[k].setAttribute('aria-checked', st.v.sex === sx[k].getAttribute('data-sg-sex') ? 'true' : 'false');
    st.root.classList.toggle('is-f', st.v.sex === 'f');
    var opts = qa(st.root, '[data-sg-opt]');
    for (var i = 0; i < opts.length; i++) {
      var g = opts[i].getAttribute('data-sg-opt');
      opts[i].setAttribute('aria-checked', st.v[g] === opts[i].getAttribute('data-sg-val') ? 'true' : 'false');
    }
  }

  /* ---------- Écrans ---------- */
  function clearTimers(st) {
    for (var i = 0; i < st.timers.length; i++) clearTimeout(st.timers[i]);
    st.timers = [];
  }
  function startScreen(st) { return st.adult && loadProfile() ? 'saved' : 'welcome'; }

  function canGo(st) {
    var s = st.screen;
    if (s === 'info') return readFields(st).filled;
    if (s === 'chest') return !!st.v.chest;
    if (s === 'belly') return !!st.v.belly;
    return s !== 'analysis';
  }
  function paintFoot(st) {
    var s = st.screen, root = st.root;
    var pri = q(root, '[data-sg-primary]'), sec = q(root, '[data-sg-secondary]');
    var flowStep = st.flow.indexOf(s) > -1;
    var txt = 'Suivant';
    if (s === 'welcome') txt = 'Commencer';
    else if (s === 'saved') txt = st.res && st.res.idx !== st.res.ideal ? 'Utiliser le ' + label(st, st.res.idx) : 'Utiliser cette taille';
    else if (s === 'analysis') txt = 'Analyse en cours';
    else if (s === 'result') txt = 'Valider mon choix';
    else if (s === 'table') txt = 'Calculer ma taille parfaite';
    pri.textContent = txt;
    pri.disabled = !canGo(st);
    pri.classList.toggle('is-busy', s === 'analysis');
    sec.hidden = !(flowStep || s === 'saved');
    sec.textContent = s === 'saved' ? 'Recalculer ma taille' : 'Retour';
    q(root, '.bsg__foot').classList.toggle('is-stack', s === 'saved');
  }
  function show(st, name, noFocus) {
    clearTimers(st);
    st.screen = name;
    var root = st.root, screens = qa(root, '[data-sg-screen]');
    for (var i = 0; i < screens.length; i++) screens[i].hidden = screens[i].getAttribute('data-sg-screen') !== name;
    var steps = q(root, '[data-sg-steps]'), pos = st.flow.indexOf(name);
    steps.hidden = pos < 0;
    var segs = qa(steps, 'span');
    for (var s = 0; s < segs.length; s++) segs[s].classList.toggle('is-on', s <= pos);
    if (name === 'info') fillFields(st);
    paintOptions(st);
    paintFoot(st);
    var body = q(root, '[data-sg-scroll]');
    if (body) body.scrollTop = 0;
    if (!noFocus) focusEl(q(root, '[data-sg-screen="' + name + '"] .bsg__h'));
  }

  function showSaved(st) {
    var p = loadProfile();
    if (!p) { show(st, 'welcome'); return; }
    st.v = { sex: p.sex || 'm', h: p.h, w: p.w, a: p.a || null, chest: p.chest || 'normal', belly: p.belly || 'normal' };
    var R = compute(st, st.v);
    st.res = R;
    var root = st.root;
    q(root, '[data-sg-saved-size]').textContent = label(st, R.ideal);
    sizeClass(q(root, '[data-sg-saved-size]'), label(st, R.ideal));
    var note = '';
    if (R.idx !== R.ideal) note = R.ideal > R.idx ? 'Ce modèle s’arrête au ' + label(st, R.idx) + NB + ': il sera un peu près du corps.' : 'Ce modèle commence au ' + label(st, R.idx) + NB + ': il sera un peu ample.';
    if (!available(st, R.idx)) note = (note ? note + ' ' : '') + 'Le ' + label(st, R.idx) + ' est épuisé sur ce modèle pour le moment.';
    var n = q(root, '[data-sg-saved-note]');
    n.textContent = note;
    n.hidden = !note;
    show(st, 'saved');
  }

  function sizeClass(node, txt) { node.classList.toggle('is-long', String(txt).length > 3); }

  function analyse(st) {
    show(st, 'analysis');
    var root = st.root, checks = qa(root, '[data-sg-check]'), meter = q(root, '[data-sg-meter]');
    for (var i = 0; i < checks.length; i++) { checks[i].classList.remove('is-done'); checks[i].classList.toggle('is-on', i === 0); }
    meter.style.width = '0%';
    var step = reduce ? 220 : 720;
    function tick(n) {
      return function () {
        checks[n].classList.remove('is-on');
        checks[n].classList.add('is-done');
        if (checks[n + 1]) checks[n + 1].classList.add('is-on');
        meter.style.width = ((n + 1) / checks.length) * 100 + '%';
      };
    }
    for (var c = 0; c < checks.length; c++) st.timers.push(setTimeout(tick(c), step * (c + 1)));
    st.timers.push(setTimeout(function () {
      st.res = compute(st, st.v);
      if (!st.adult) st.memo = st.res;
      showResult(st);
    }, step * checks.length + (reduce ? 120 : 380)));
  }

  function showResult(st) {
    var R = st.res, root = st.root, rows = st.D.rows, size = label(st, R.idx);
    var sz = q(root, '[data-sg-r-size]');
    sz.textContent = size;
    sizeClass(sz, size);
    var text;
    if (st.adult) text = 'C’est la taille qui correspond le mieux à ta morphologie.';
    else text = 'Elle est prévue pour un enfant de ' + rows[R.idx].h[0] + ' à ' + rows[R.idx].h[1] + NB + 'cm.';
    q(root, '[data-sg-r-text]').textContent = text;
    q(root, '[data-sg-r-conf]').textContent = R.conf + NB + '%';
    q(root, '[data-sg-r-bar]').style.width = R.conf + '%';
    var note = '';
    if (R.edge === 'up') {
      if (st.adult) note = R.ideal > R.idx ? 'On te conseillerait le ' + label(st, R.ideal) + ', mais ce modèle s’arrête au ' + size + NB + ': il sera un peu près du corps.' : 'C’est la plus grande taille de ce modèle' + NB + ': il sera un peu près du corps.';
      else note = 'C’est la plus grande taille de ce modèle' + NB + ': il sera un peu juste.';
    } else if (R.edge === 'down') {
      note = st.adult ? 'C’est la plus petite taille de ce modèle' + NB + ': il sera un peu ample.' : 'C’est la plus petite taille de ce modèle' + NB + ': il sera un peu grand.';
    }
    if (!available(st, R.idx)) note = (note ? note + ' ' : '') + 'Cette taille est épuisée sur ce modèle pour le moment.';
    var n = q(root, '[data-sg-r-note]');
    n.textContent = note;
    n.hidden = !note;
    markTable(st, R.idx);
    show(st, 'result');
  }

  function markTable(st, idx) {
    var trs = qa(st.root, '[data-sg-row]');
    for (var r = 0; r < trs.length; r++) trs[r].classList.toggle('is-reco', idx > -1 && trs[r].getAttribute('data-sg-row') === st.D.rows[idx].k);
  }

  function next(st) {
    var s = st.screen;
    if (s === 'welcome') { show(st, 'info'); return; }
    if (s === 'saved') { selectSize(st, st.res.idx, true); close(st.root); return; }
    if (s === 'info') {
      var chk = showErrors(st);
      if (st.adult && !sexOk(st)) { focusEl(q(st.root, '[data-sg-sex]')); return; }
      if (!chk.r.ok) { focusEl(chk.first || q(st.root, '[data-sg-screen="info"] input')); return; }
      if (st.adult) show(st, 'chest'); else analyse(st);
      return;
    }
    if (s === 'chest') { if (st.v.chest) show(st, 'belly'); return; }
    if (s === 'belly') { if (st.v.belly) analyse(st); return; }
    if (s === 'result') {
      if (st.adult) saveProfile(st.v);
      selectSize(st, st.res.idx, true);
      st.screen = null;
      close(st.root);
      refreshAll();
      return;
    }
    if (s === 'table') { if (startScreen(st) === 'saved') showSaved(st); else show(st, 'welcome'); }
  }
  function back(st) {
    var s = st.screen, pos = st.flow.indexOf(s);
    if (s === 'saved') { show(st, 'info'); return; }
    if (pos > 0) { show(st, st.flow[pos - 1]); return; }
    if (pos === 0) { if (startScreen(st) === 'saved') showSaved(st); else show(st, 'welcome'); }
  }
  function sexOk(st) {
    var box = q(st.root, '[data-sg-err="sex"]'), ok = !!st.v.sex;
    if (box) { box.hidden = ok; box.textContent = ok ? '' : 'Choisis Homme ou Femme.'; }
    var f = q(st.root, '[data-sg-field="sex"]');
    if (f) f.classList.toggle('is-bad', !ok);
    return ok;
  }
  function restart(st) {
    st.v = { sex: null, h: null, w: null, a: null, chest: null, belly: null };
    st.res = null;
    var errs = qa(st.root, '[data-sg-err]');
    for (var i = 0; i < errs.length; i++) errs[i].hidden = true;
    var bad = qa(st.root, '.is-bad');
    for (var j = 0; j < bad.length; j++) bad[j].classList.remove('is-bad');
    show(st, 'info');
  }

  /* ---------- Sélection de la taille sur la fiche ---------- */
  function sizeInputs(st) {
    var opt = 'option' + (st.cfg.pos || 1), form = st.cfg.form, out = [];
    var inputs = document.querySelectorAll('[data-variant-input]');
    for (var i = 0; i < inputs.length; i++) {
      if (inputs[i].getAttribute('form') === form && inputs[i].getAttribute('data-index') === opt) out.push(inputs[i]);
    }
    return out;
  }
  function selectedKey(st) {
    var ins = sizeInputs(st);
    for (var i = 0; i < ins.length; i++) {
      if (ins[i].tagName === 'SELECT') return norm(ins[i].value);
      if (ins[i].type === 'radio' && ins[i].checked) return norm(ins[i].value);
    }
    return null;
  }
  function tagSize(st, idx) {
    var key = idx > -1 ? st.D.rows[idx].k : null, ins = sizeInputs(st);
    for (var i = 0; i < ins.length; i++) {
      var wrap = ins[i].closest('.variant-input');
      if (wrap) wrap.classList.toggle('bsg-reco', key !== null && ins[i].type === 'radio' && norm(ins[i].value) === key);
    }
  }
  function selectSize(st, idx, tag) {
    var key = st.D.rows[idx].k, ins = sizeInputs(st), done = false;
    for (var i = 0; i < ins.length; i++) {
      var inp = ins[i];
      if (inp.tagName === 'SELECT') {
        for (var o = 0; o < inp.options.length; o++) {
          if (norm(inp.options[o].value) === key) {
            inp.value = inp.options[o].value;
            inp.dispatchEvent(new Event('change', { bubbles: true }));
            done = true;
          }
        }
      } else if (inp.type === 'radio' && norm(inp.value) === key) {
        if (!inp.checked) inp.click();
        done = true;
      }
    }
    if (tag) tagSize(st, idx);
    return done;
  }

  /* ---------- Recommandation sous les tailles ---------- */
  function pdpBox(st) { return document.querySelector('[data-bsg-pdp="' + st.root.id + '"]'); }
  function renderPdp(st) {
    var box = pdpBox(st);
    if (!box) return;
    var text = q(box, '[data-bsg-pdp-text]'), acts = q(box, '[data-bsg-pdp-actions]');
    if (!box.__def) box.__def = { text: text.textContent, acts: acts.innerHTML };
    var R = null;
    if (st.adult) { var p = loadProfile(); if (p) R = compute(st, p); }
    else if (st.memo) R = st.memo;
    if (!R) {
      text.textContent = box.__def.text;
      acts.innerHTML = box.__def.acts;
      box.classList.remove('is-set');
      tagSize(st, -1);
      return;
    }
    var size = label(st, R.idx), lead = st.adult ? 'D’après ton diagnostic ' + BRAND + ', ' : 'D’après le diagnostic ' + BRAND + ', ';
    text.textContent = '';
    var b = el('b', null, size);
    if (st.adult && R.idx !== R.ideal) {
      text.appendChild(document.createTextNode(lead + 'ta taille est le ' + label(st, R.ideal) + ', mais ce modèle ' + (R.ideal > R.idx ? 's’arrête' : 'commence') + ' au '));
      text.appendChild(b);
      text.appendChild(document.createTextNode('.'));
    } else {
      text.appendChild(document.createTextNode(lead + 'la taille '));
      text.appendChild(b);
      text.appendChild(document.createTextNode(st.adult ? ' est parfaite pour toi.' : ' est parfaite pour l’enfant.'));
    }
    if (!available(st, R.idx)) text.appendChild(document.createTextNode(' Elle est épuisée pour le moment.'));
    acts.textContent = '';
    if (selectedKey(st) === st.D.rows[R.idx].k) {
      var ok = el('p', 'bsg-pdp__ok');
      ok.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 12.5l4 4 8-9"/></svg>';
      ok.appendChild(document.createTextNode('Taille ' + size + ' sélectionnée'));
      acts.appendChild(ok);
    } else {
      var use = el('button', 'bsg-pdp__use', R.idx !== R.ideal ? 'Utiliser le ' + size : 'Utiliser cette taille');
      use.type = 'button';
      use.setAttribute('data-bsg-use', st.root.id);
      acts.appendChild(use);
    }
    var again = el('button', 'bsg-pdp__again', st.adult ? 'Recalculer ma taille' : 'Recalculer sa taille');
    again.type = 'button';
    again.setAttribute('data-bled-size-guide-trigger', '');
    again.setAttribute('data-bled-size-guide-target', st.root.id);
    again.setAttribute('data-sg-open', 'restart');
    again.setAttribute('aria-haspopup', 'dialog');
    acts.appendChild(again);
    box.classList.add('is-set');
    tagSize(st, R.idx);
  }
  function refreshAll() {
    var roots = document.querySelectorAll('[data-bled-size-guide]');
    for (var i = 0; i < roots.length; i++) renderPdp(setup(roots[i]));
  }

  /* ---------- Ouverture et fermeture ---------- */
  function open(root, trigger) {
    var st = setup(root);
    if (root.parentNode !== document.body) document.body.appendChild(root);
    lastTrigger = trigger || document.activeElement;
    active = root;
    root.hidden = false;
    root.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('bsg-lock');
    root.classList.remove('is-in');
    void root.offsetWidth;
    root.classList.add('is-in');
    var mode = (trigger && trigger.getAttribute('data-sg-open')) || 'finder';
    if (mode === 'table') {
      var p = st.adult ? loadProfile() : null;
      markTable(st, p ? compute(st, p).idx : st.memo ? st.memo.idx : -1);
      show(st, 'table', true);
    } else if (mode === 'restart') {
      var pr = st.adult ? loadProfile() : null;
      if (pr) st.v = { sex: pr.sex || 'm', h: pr.h, w: pr.w, a: pr.a || null, chest: pr.chest || null, belly: pr.belly || null };
      show(st, 'info', true);
    } else if (st.screen && st.screen !== 'table' && st.screen !== 'welcome' && st.screen !== 'saved') {
      if (st.screen === 'analysis') analyse(st); else show(st, st.screen, true);
    } else if (startScreen(st) === 'saved') {
      showSaved(st);
    } else {
      show(st, 'welcome', true);
    }
    focusEl(q(root, '.bsg__sheet'));
  }
  function close(root) {
    if (!root || root.hidden) return;
    var st = root.__bsg;
    if (st) {
      clearTimers(st);
      if (st.screen === 'analysis') st.screen = st.adult ? 'belly' : 'info';
    }
    root.hidden = true;
    root.classList.remove('is-in');
    root.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('bsg-lock');
    active = null;
    if (st) renderPdp(st);
    var t = lastTrigger;
    lastTrigger = null;
    if (t && t.focus && document.documentElement.contains(t)) focusEl(t);
    else if (st) focusEl(q(pdpBox(st) || document.body, 'button'));
  }
  function modalFor(trigger) {
    var id = trigger.getAttribute('data-bled-size-guide-target');
    var m = id ? document.getElementById(id) : null;
    if (m) return m;
    var form = trigger.closest('form');
    return form ? form.querySelector('[data-bled-size-guide]') : null;
  }

  /* ---------- Événements ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target && e.target.closest ? e.target : null;
    if (!t) return;
    var trig = t.closest('[data-bled-size-guide-trigger]');
    if (trig) {
      var m = modalFor(trig);
      if (m) { e.preventDefault(); e.stopPropagation(); open(m, trig); }
      return;
    }
    var use = t.closest('[data-bsg-use]');
    if (use) {
      var mm = document.getElementById(use.getAttribute('data-bsg-use'));
      if (mm) {
        var su = setup(mm), pu = su.adult ? loadProfile() : null, Ru = pu ? compute(su, pu) : su.memo;
        if (Ru) selectSize(su, Ru.idx, true);
        renderPdp(su);
      }
      return;
    }
    var root = t.closest('[data-bled-size-guide]');
    if (!root) return;
    var st = setup(root), a;
    if (t.closest('[data-bled-size-guide-close]')) { e.preventDefault(); close(root); return; }
    if ((a = t.closest('[data-sg-primary]'))) { if (!a.disabled) next(st); return; }
    if (t.closest('[data-sg-secondary]')) { back(st); return; }
    if ((a = t.closest('[data-sg-sex]'))) {
      st.v.sex = a.getAttribute('data-sg-sex');
      paintOptions(st);
      if (q(st.root, '[data-sg-field="sex"].is-bad')) sexOk(st);
      paintFoot(st);
      return;
    }
    if ((a = t.closest('[data-sg-opt]'))) {
      st.v[a.getAttribute('data-sg-opt')] = a.getAttribute('data-sg-val');
      paintOptions(st);
      paintFoot(st);
      return;
    }
    if ((a = t.closest('[data-sg-unit]'))) {
      readFields(st);
      if (a.getAttribute('data-sg-unit') === 'h') st.unitH = st.unitH === 'cm' ? 'ft' : 'cm';
      else st.unitW = st.unitW === 'kg' ? 'lb' : 'kg';
      fillFields(st);
      showErrors(st);
      paintFoot(st);
      return;
    }
    if ((a = t.closest('[data-sg-go]'))) { show(st, a.getAttribute('data-sg-go')); return; }
    if (t.closest('[data-sg-restart]')) { restart(st); return; }
  });

  document.addEventListener('input', function (e) {
    var inp = e.target;
    if (!inp || !inp.hasAttribute || !inp.hasAttribute('data-sg-input')) return;
    var root = inp.closest('[data-bled-size-guide]');
    if (!root) return;
    var st = setup(root);
    var clean = '', s = inp.value;
    for (var i = 0; i < s.length; i++) {
      var ch = s.charAt(i);
      if ((ch >= '0' && ch <= '9') || ((ch === ',' || ch === '.') && inp.getAttribute('data-sg-input') === 'w' && clean.indexOf(',') < 0)) clean += ch === '.' ? ',' : ch;
    }
    if (clean !== s) inp.value = clean;
    readFields(st);
    var field = inp.closest('[data-sg-field]');
    if (field && field.classList.contains('is-bad')) showErrors(st, field.getAttribute('data-sg-field'));
    paintFoot(st);
  });

  document.addEventListener('focusout', function (e) {
    var inp = e.target;
    if (!inp || !inp.hasAttribute || !inp.hasAttribute('data-sg-input')) return;
    var root = inp.closest('[data-bled-size-guide]');
    if (!root || !inp.value) return;
    var field = inp.closest('[data-sg-field]');
    showErrors(setup(root), field ? field.getAttribute('data-sg-field') : null);
  });

  document.addEventListener('keydown', function (e) {
    if (!active) return;
    var st = active.__bsg;
    if (e.key === 'Escape' || e.key === 'Esc') { e.preventDefault(); close(active); return; }
    if (e.key === 'Enter' && e.target && e.target.hasAttribute && e.target.hasAttribute('data-sg-input')) {
      e.preventDefault();
      var pri = q(active, '[data-sg-primary]');
      if (pri && !pri.disabled) next(st); else showErrors(st);
      return;
    }
    var radio = e.target && e.target.closest && (e.target.closest('[data-sg-opt]') || e.target.closest('[data-sg-sex]'));
    if (radio && (e.key === 'ArrowRight' || e.key === 'ArrowLeft' || e.key === 'ArrowDown' || e.key === 'ArrowUp')) {
      e.preventDefault();
      var group = qa(radio.parentNode, 'button'), at = Array.prototype.indexOf.call(group, radio);
      var to = group[(at + (e.key === 'ArrowRight' || e.key === 'ArrowDown' ? 1 : group.length - 1)) % group.length];
      focusEl(to);
      to.click();
      return;
    }
    if (e.key !== 'Tab') return;
    var sheet = q(active, '.bsg__sheet');
    var list = sheet.querySelectorAll('button,a[href],input,[tabindex="0"]'), f = [];
    for (var i = 0; i < list.length; i++) if (list[i].offsetParent !== null && !list[i].disabled && list[i].tabIndex !== -1) f.push(list[i]);
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1], cur = document.activeElement;
    if (e.shiftKey && (cur === first || cur === sheet || !sheet.contains(cur))) { e.preventDefault(); focusEl(last); }
    else if (!e.shiftKey && (cur === last || !sheet.contains(cur))) { e.preventDefault(); focusEl(first); }
  });

  // Changement de taille à la main : l'encadré dit si la taille conseillée est celle choisie.
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || !t.hasAttribute || !t.hasAttribute('data-variant-input')) return;
    setTimeout(refreshAll, 0);
  });
  window.addEventListener('storage', function (e) { if (e.key === KEY) refreshAll(); });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', refreshAll);
  else refreshAll();

  // Ouverture depuis un autre script : BledSizeGuide.open('BledSizeGuide-…', 'finder' | 'table' | 'restart')
  window.BledSizeGuide = {
    open: function (id, mode) {
      var m = document.getElementById(id);
      if (m) open(m, { getAttribute: function () { return mode || 'finder'; } });
    }
  };
})();
